import { handleAxiosError } from '../helpers'
import { instance } from '../helpers'

export const weeklyExposureServices = {
  post,
}

function post(params) {
  return instance
    .post('/weekly-exposure', params)
    .then(response => {
      return response
    })
    .catch(error => {
      return handleAxiosError(error)
    })
}
